/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R1_BodyInputs */

const tr_iletisim_s7_r1_body = /** @type {(inputs: Iletisim_S7_R1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T.C. Ticaret Bakanlığı bünyesinde, parasal sınırlar dahilindeki uyuşmazlıklar için ücretsiz başvuru.`)
};

const en_iletisim_s7_r1_body = /** @type {(inputs: Iletisim_S7_R1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosted within the T.C. Ticaret Bakanlığı (Ministry of Trade), free of charge for disputes within the monetary limits.`)
};

const de_iletisim_s7_r1_body = /** @type {(inputs: Iletisim_S7_R1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angesiedelt beim T.C. Ticaret Bakanlığı (Handelsministerium), kostenlose Antragstellung für Streitigkeiten innerhalb der Wertgrenzen.`)
};

const ru_iletisim_s7_r1_body = /** @type {(inputs: Iletisim_S7_R1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действуют при T.C. Ticaret Bakanlığı (Министерство торговли), бесплатное обращение по спорам в пределах установленных денежных лимитов.`)
};

/**
* | output |
* | --- |
* | "Hosted within the T.C. Ticaret Bakanlığı (Ministry of Trade), free of charge for disputes within the monetary limits." |
*
* @param {Iletisim_S7_R1_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r1_body = /** @type {((inputs?: Iletisim_S7_R1_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R1_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r1_body(inputs)
	if (locale === "de") return de_iletisim_s7_r1_body(inputs)
	if (locale === "ru") return ru_iletisim_s7_r1_body(inputs)
	return tr_iletisim_s7_r1_body(inputs)
});